// Open or create the IndexedDB database
export function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    // Using version 3 for all stores: forms, formData, formKeyData, pendingSync
    const request = indexedDB.open("pdf_reader", 4);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      

      // Create object store "forms" for saving forms
      if (!db.objectStoreNames.contains("forms")) {
        db.createObjectStore("forms", { keyPath: "id" });
      
      }

      // Create object store "formData" for saving template details
      if (!db.objectStoreNames.contains("formData")) {
        db.createObjectStore("formData", { keyPath: "id" });
      
      }

      if (!db.objectStoreNames.contains("formKeyData")) {
        db.createObjectStore("formKeyData", { keyPath: "id" });
      
      }


      if (!db.objectStoreNames.contains("submittedFormKeyData")) {
        db.createObjectStore("submittedFormKeyData", { keyPath: "id" });
        
      }

      if (!db.objectStoreNames.contains("saveFormKeyData")) {
        db.createObjectStore("saveFormKeyData", { keyPath: "id" });
        
      }

      // Create object store "pendingSync" for offline-to-online sync queue
      if (!db.objectStoreNames.contains("pendingSync")) {
        db.createObjectStore("pendingSync", { keyPath: "id" });
        
      }
      
      
    };

    request.onsuccess = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      
      resolve(db);
    };
    request.onerror = (event) =>
      reject("IndexedDB error: " + (event.target as IDBOpenDBRequest).error);
  });
}

export async function saveItem(store: string, data: any): Promise<boolean> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    try {
      // Verify the store exists
      if (!db.objectStoreNames.contains(store)) {
        
        reject(new Error(`Object store "${store}" does not exist`));
        return;
      }

      const tx = db.transaction(store, "readwrite");
      tx.objectStore(store).put(data);

      tx.oncomplete = () => {
        
        resolve(true);
      };
      tx.onerror = (err) => {
       
        reject(err);
      };
    } catch (error) {
      
      reject(error);
    }
  });
}

export async function getItem(store: string, id: any): Promise<any> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, "readonly");
    const req = tx.objectStore(store).get(id);

    req.onsuccess = () => resolve(req.result);
    req.onerror = (err) => reject(err);
  });
}

export async function getAll(store: string): Promise<any[]> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, "readonly");
    const req = tx.objectStore(store).getAll();

    req.onsuccess = () => resolve(req.result);
    req.onerror = (err) => reject(err);
  });
}

// Delete a specific item from a store by ID
export async function deleteItem(store: string, id: any): Promise<boolean> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    try {
      if (!db.objectStoreNames.contains(store)) {
        
        resolve(false);
        return;
      }

      const tx = db.transaction(store, "readwrite");
      const req = tx.objectStore(store).delete(id);

      req.onsuccess = () => {
       
        resolve(true);
      };
      req.onerror = (err) => {
       
        reject(err);
      };
    } catch (error) {
     
      reject(error);
    }
  });
}

// Clear all data from a specific store
export async function clearStore(store: string): Promise<boolean> {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    try {
      if (!db.objectStoreNames.contains(store)) {
        
        resolve(false);
        return;
      }

      const tx = db.transaction(store, "readwrite");
      const req = tx.objectStore(store).clear();

      req.onsuccess = () => {
        
        resolve(true);
      };
      req.onerror = (err) => {
        
        reject(err);
      };
    } catch (error) {
      
      reject(error);
    }
  });
}

// Clear all data from all stores in the database
export async function clearAllStores(): Promise<void> {
  const db = await openDB();
  const storeNames = Array.from(db.objectStoreNames);

  

  for (const storeName of storeNames) {
    try {
      await clearStore(storeName);
    } catch (error) {
  
    }
  }

  
}
